import { isRenderedAsIsland } from '@/utils/routing';

export default function isEmbedded() {
  return isRenderedAsIsland() || window.location.search.includes('embedded=true');
}
